<template>
    <li
        class="primaryNav__listItem"
        @mouseenter="openDropdown($event, false)"
        @mouseleave="closeDropdown($event, false)"
        @keyup.escape="closeDropdown($event, true)"
    >
        <a
            :href="navItemData.url"
            class="primaryNav__navLink -dropdown js-parentLink"
            :class="{ '-active': dropdownOpen }"
        >
            {{ navItemData.title }}
        </a>
        <button
            v-if="hasDropdown"
            class="primaryNav__dropdownOpen"
            :aria-expanded="`${dropdownOpen}`"
            :aria-controls="`${navItemData.title}__dropdown`"
            @keydown.enter="openDropdown($event, true)"
            @keydown.space="openDropdown($event, true)"
        >
            Show submenu for "{{ navItemData.title }}"
            <i class="fal fa-angle-down primaryNav__dropdownOpenIcon" />
        </button>
        <transition name="dropdown">
            <div
                v-if="dropdownOpen"
                :id="`${navItemData.title}__dropdown`"
                class="primaryNav__dropdown"
            >
                <ul class="primaryNav__dropdownList">
                    <li
                        v-for="(child, index) in navItemData.children"
                        :key="child.url"
                        class="primaryNav__dropdownListItem"
                    >
                        <a
                            :href="child.url"
                            class="primaryNav__dropdownLink js-dropdownLink"
                            @keyup.down="nextLink($event, index)"
                            @keyup.up="previousLink($event, index)"
                            @keyup.tab.exact="nextLink($event, index)"
                            @keyup.shift.tab="previousLink($event, index)"
                        >
                            {{ child.title }}
                        </a>
                    </li>
                    <li class="primaryNav__dropdownListItem -close">
                        <button
                            :aria-label="`Close submenu for ${navItemData.title}`"
                            class="primaryNav__dropdownLink js-dropdownLink"
                            @keyup.enter="closeDropdown($event, true)"
                            @keyup.space="closeDropdown($event, true)"
                            @keyup.down="nextLink($event, navItemData.children.length)"
                            @keyup.up="previousLink($event, navItemData.children.length)"
                            @keyup.tab.exact="nextLink($event, navItemData.children.length)"
                            @keyup.shift.tab="previousLink($event, navItemData.children.length)"
                        >
                            Close
                        </button>
                    </li>
                </ul>
            </div>
        </transition>
    </li>
</template>

<script>
export default {

    props: {
        navItemData: {
            type: Object,
            required: true,
        },

        hasDropdown: {
            type: Boolean,
            default: false,
        },
    },

    data () {
        return {
            dropdownOpen: false,
            keyboardFocused: false,
        }
    },

    methods: {
        openDropdown (event, focusFirst) {
            if (!this.hasDropdown) {
                return
            }

            this.$emit('submenuopen')

            window.addEventListener('keydown', this.windowScrollFix)

            this.dropdownOpen = true

            if (focusFirst) {
                this.keyboardFocused = true
                this.focusFirstItem()
            }
        },

        closeDropdown (event, focusParent) {
            if (!this.hasDropdown) {
                return
            }

            this.$emit('submenuclose')

            window.removeEventListener('keydown', this.windowScrollFix)

            this.dropdownOpen = false
            this.keyboardFocused = false

            if (focusParent) {
                this.focusParentLink()
            }
        },

        focusFirstItem () {
            setTimeout(() => {
                const firstLink = this.$el.querySelector('.js-dropdownLink')

                firstLink.focus()
            }, 0)
        },

        focusParentLink () {
            setTimeout(() => {
                const parentLink = this.$el.querySelector('.js-parentLink')

                parentLink.focus()
            }, 0)
        },

        nextLink (event, index) {
            const dropdownLinks = [...this.$el.querySelectorAll('.js-dropdownLink')]
            const [firstDropdownLink] = dropdownLinks
            const nextDropdownLink = dropdownLinks[index + 1]

            if (index === dropdownLinks.length - 1) {
                firstDropdownLink.focus()
                return
            }

            nextDropdownLink.focus()
        },

        previousLink (event, index) {
            const dropdownLinks = [...this.$el.querySelectorAll('.js-dropdownLink')]
            const lastDropdownLink = dropdownLinks[dropdownLinks.length - 1]
            const previousDropdownLink = dropdownLinks[index - 1]

            if (index === 0) {
                lastDropdownLink.focus()
                return
            }

            previousDropdownLink.focus()
        },

        windowScrollFix (event) {
            if (
                event.keyCode === 38 || // Up
                event.keyCode === 40 || // Down
                event.keyCode === 9 || // Tab
                event.keyCode === 16 // Shift
            ) {
                event.preventDefault()
            }
        },
    },

}
</script>
